module.exports = __webpack_public_path__ + "img/dashboard.e90217cc.png";